module.exports = __webpack_public_path__ + "static/media/empty_state_card.62e241d5.svg";